var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlide1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.912 186.215L54.9945 218.641C50.0921 221.302 43.9768 219.525 41.2348 214.643C40.434 213.108 40.0106 211.402 40 209.668V137.088C40 144.284 44.0573 148.726 54.7299 153.701L119.912 186.215Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9526 20H150.695C177.773 20 199.735 30.6605 200 57.9337V209.668C199.989 211.374 199.565 213.051 198.765 214.555C197.479 217.007 195.259 218.827 192.615 219.598C189.97 220.368 187.128 220.023 184.741 218.641L119.912 186.215L54.7299 153.701C44.0573 148.726 40 144.284 40 137.088V57.9337C40 30.6605 61.9625 20 88.9526 20ZM82.2494 96.2227H157.486C161.822 96.2227 165.337 92.6828 165.337 88.3161C165.337 83.9494 161.822 80.4096 157.486 80.4096H82.2494C77.914 80.4096 74.3994 83.9494 74.3994 88.3161C74.3994 92.6828 77.914 96.2227 82.2494 96.2227Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide1);
export default __webpack_public_path__ + "static/media/slide-1.4f6e053231dfd32b1ca2f5ce15d1a75b.svg";
export { ForwardRef as ReactComponent };